var map = {
	"./img_0.png": 704,
	"./img_1.png": 705,
	"./img_10.png": 706,
	"./img_2.png": 707,
	"./img_3.png": 708,
	"./img_4.png": 709,
	"./img_5.png": 710,
	"./img_6.png": 711,
	"./img_7.png": 712,
	"./img_8.png": 713,
	"./img_9.png": 714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 703;